import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import { store } from './components/stores/store';
import ChangePasswordPopup from './components/modules/users/childcomponents/userchangepassword';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';
import { AxiosInterceptor } from './components/services/api.interceptor';

export const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
      <AxiosInterceptor msalinstance={msalInstance}>
      <BrowserRouter>
        <App />
        {/* <ChangePasswordPopup /> */}
      </BrowserRouter>
      </AxiosInterceptor>
      </MsalProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
